let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gXaoF")).then(() => parcelRequire('56WVQ'));